<template>
    <div class="c-global-search" :class="{ 'is-searching': searching==true }" :data-component-name="$options.name">
        <div class="c-global-search__toggle" @click="showResults();selectedItem=-1"
            onclick="this.closest('.c-header').classList.toggle('is-search-active'); document.querySelector('.js-search_input').focus();">
            <SvgIcon name="search" v-if="!$apollo.loading" />
            <q-spinner v-else color="white" size="1em" :thickness="10" />
        </div>
        <div class="c-global-search__input__wrap">
            <input type="text" class="c-global-search__input js-search_input" placeholder="Rechercher"
                v-model="searchText" @click="showResults()" @input="sentenceMatch=false" />
        </div>

        <div class="c-global-search__filters">
            <div class="c-filters-list">
                <div class="c-filters-list__item">
                    <button class="o-button -sm" ref="myProjects" @click="setSearchFilters('myProjects')"
                        :class="{ 'is-active' : searchFilters.includes('myProjects') }"
                        title="Afficher les projets dont je suis chargé de projet">
                        Mes projects
                    </button>
                </div>
                <div class="c-filters-list__item">
                    <button class="o-button -sm" ref="me" @click="setSearchFilters('me')"
                        :class="{ 'is-active' : searchFilters.includes('me') }"
                        title="Afficher des résultats qui me concernent">
                        Moi
                    </button>
                </div>
                <div class="c-filters-list__item">
                    <button class="o-button -sm" ref="activeProjects"
                        @click="setSearchFilters('activeProjects', ['future', 'done'])"
                        :class="{ 'is-active' : searchFilters.includes('activeProjects') }" title="Projets en cours">
                        En cours
                    </button>
                </div>
                <div class="c-filters-list__item">
                    <button class="o-button -sm" ref="future"
                        @click="setSearchFilters('future', ['activeProjects', 'done'])"
                        :class="{ 'is-active' : searchFilters.includes('future') }" title="Projets à venir">
                        À venir
                    </button>
                </div>
                <div class="c-filters-list__item">
                    <button class="o-button -sm" ref="done"
                        @click="setSearchFilters('done', ['activeProjects', 'future'])"
                        :class="{ 'is-active' : searchFilters.includes('done') }" title="Projets terminés">
                        Terminés
                    </button>
                </div>
                <div class="c-filters-list__item">
                    <button class="o-button -sm" ref="done" @click="setStatusFilter('NEWPROJECT')"
                        :class="{ 'is-active' : statusFilter=='NEWPROJECT' }" title="Nouveaux projets">
                        Nouveaux
                    </button>
                </div>
                <div class="c-filters-list__item">
                    <button class="o-button -sm" ref="done" @click="setStatusFilter('TOPLAN')"
                        :class="{ 'is-active' : statusFilter=='TOPLAN' }" title="Projets à planifier">
                        À planifier
                    </button>
                </div>
            </div>
        </div>

        <q-menu ref="js-search-result" id="js-search-result" :no-parent-event="true" :no-focus="true"
            content-class="c-global-search__result-wrapper" :square="true"
            @hide="$document.querySelector('.c-header').classList.remove('is-search-active')">
            <!-- <div class="c-global-search__result-wrapper"> -->
            <a id="containerTop"></a>
            <div class="-result-group no-wrap" :class="{ 'has-results': projects.data.length>0 }">
                <h4 class="" onclick="this.closest('.-result-group').classList.toggle('is-collapsed');">
                    <q-icon name="expand_more" class="-button-expand" />
                    Projets
                    <q-badge class="-badge float-right q-mr-xs" size="sm" rounded align="middle"
                        :label="projects.paginatorInfo.total"></q-badge>
                </h4>
                <div clickable :key="pi" v-for="(project, pi) in projects.data" class="-item cursor-pointer" :class="{
                                    '-is-last-child' : pi==projects.data.length-1,
                                    '-is-selected' : selectedItem==pi,
                                }" @click="jumpToProject(project)" :ref="'projectGS-'+pi" :id="'projectGS-'+pi">
                    <div class="-name" :class="{'-is-archived': project.status=='ARCHIVED' }">
                        <span>
                            <!-- <q-icon class="-icon q-mr-xs" name="archive" v-if="project.status=='ARCHIVED'" /> -->
                            {{ project.name}}
                            <!-- <small v-if="project.status=='ARCHIVED'" class="q-ml-md">Archivé</small> -->
                        </span>
                        <ProjectCardToggle class="q-mr-xs" :projectID="project.id" :size="'16px'" />
                    </div>
                    <div class="-description u-text-truncate-8lines"
                        v-if="project.description && project.description.trim()!=''"
                        v-html="$nl2br(project.description)">
                    </div>
                    <div class="-description q-mt-sm">
                        <span class="q-mr-md">
                            <q-icon class="-icon" name="event" />
                            du {{ project.start_date }}
                            au {{ project.end_date }}
                        </span>
                    </div>
                    <div class="-description -faded">
                        <span
                            v-if="project.status=='ARCHIVED' || project.status=='TOPLAN' || project.status=='NEWPROJECT'"
                            class="q-mr-sm text-no-wrap -badge-archived__wrapper">
                            <span class="-badge-archived" v-if="project.status=='ARCHIVED'">
                                Archivé
                            </span>
                            <span class="-badge-archived" v-if="project.status=='TOPLAN'">
                                À planifier
                            </span>
                            <span class="-badge-archived" v-if="project.status=='NEWPROJECT'">
                                Nouveau projet
                            </span>
                        </span>
                        <span v-if="project.projectManager" class="q-mr-sm text-no-wrap" title="Chargé de projet">
                            <q-icon class="-icon q-mr-xs" name="record_voice_over" />
                            <UserProfileInfo :userProfile="project.projectManager"
                                :custom-content="project.projectManager.name" class="q-mr-xs" :size="'16px'" />
                        </span>
                        <span :key="ncu" v-for="(customer, ncu) in project.customers" class="q-mr-sm text-no-wrap"
                            title="Client">
                            <q-icon class="-icon q-mr-xs" name="business" />
                            <!-- {{ customer.name }} -->
                            <UserProfileInfo :userProfile="customer" :custom-content="customer.name" class="q-mr-xs"
                                :size="'16px'" />
                        </span>
                        <span class="q-mr-sm text-no-wrap" :title="'Modifié par '+project.updated_by.name"
                            v-if="project.updated_by">
                            <q-icon class="-icon q-mr-xs" name="edit" />{{ project.updated_at }}
                        </span>
                        <span v-if="project.relevance!=null" class="q-mr-sm text-no-wrap"
                            title="Pertinence de recherche">
                            <q-icon class="-icon q-mr-xs" name="trending_up" />{{ project.relevance.toFixed(3) }}
                        </span>
                    </div>
                </div>

                <div v-if="projects.paginatorInfo.hasMorePages" class="-load-more">
                    <span ref="loadMoreProjects" class="cursor-pointer" v-if="!$apollo.loading"
                        @click.stop="loadMoreResults(projects.paginatorInfo.currentPage+1, 'projects')">
                        Charger plus de résultats ({{projects.paginatorInfo.total-projects.data.length}})
                    </span>
                    <span v-else class="is-disabled">
                        Charger plus de résultats ({{projects.paginatorInfo.total-projects.data.length}})
                    </span>
                </div>

            </div>



            <div class="-result-group no-wrap" :class="{ 'has-results': userProfiles.data.length>0 }">
                <h4 class="" onclick="this.closest('.-result-group').classList.toggle('is-collapsed');">
                    <q-icon name="expand_more" class="-button-expand" />
                    Utilisateurs
                    <q-badge class="-badge float-right q-mr-xs" size="sm" rounded align="middle"
                        :label="userProfiles.paginatorInfo.total"></q-badge>
                </h4>
                <div :key="pu" v-for="(userProfile, pu) in userProfiles.data" class="-item"
                    :class="{'-is-last-child' : pu==userProfiles.data.length-1}">
                    <div class="-name">
                        <span>
                            {{ userProfile.name}}
                            <q-icon class="q-mr-xs cursor-pointer" name="find_replace"
                                title="Rechercher la phrase exacte" size="16px"
                                @click.stop="sentenceMatch=true; searchText=userProfile.name;" />
                        </span>
                        <UserProfileInfo :currentDate="currentDate" :userProfile="userProfile" class="q-mr-xs"
                            :size="'16px'" />
                    </div>
                    <div class="-description" v-if="userProfile.email.trim()!=''">
                        <span class="q-mr-sm text-no-wrap">
                            {{ userProfile.email }}
                            <q-icon class="q-mr-xs cursor-pointer" name="find_replace"
                                title="Rechercher la phrase exacte" size="16px"
                                @click.stop="sentenceMatch=true; searchText=userProfile.email;" />
                        </span>

                        <span v-if="userProfile.relevance!=null" class="q-mr-sm text-no-wrap -faded"
                            title="Pertinence de recherche">
                            <q-icon class="-icon q-mr-xs" name="trending_up" />
                            {{ userProfile.relevance.toFixed(3) }}
                        </span>

                    </div>
                </div>
                <div v-if="userProfiles.paginatorInfo.hasMorePages" class="-load-more">
                    <span class="cursor-pointer" v-if="!$apollo.loading"
                        @click.stop="loadMoreResults(userProfiles.paginatorInfo.currentPage+1, 'userProfiles')">
                        Charger plus de résultats ({{userProfiles.paginatorInfo.total-userProfiles.data.length}})
                    </span>
                    <span v-else class="is-disabled">
                        Charger plus de résultats ({{userProfiles.paginatorInfo.total-userProfiles.data.length}})
                    </span>
                </div>
            </div>



            <div class="-result-group no-wrap" :class="{ 'has-results': customers.data.length>0 }">
                <h4 class="" onclick="this.closest('.-result-group').classList.toggle('is-collapsed');">
                    <q-icon name="expand_more" class="-button-expand" />
                    Clients
                    <q-badge class="-badge float-right q-mr-xs" size="sm" rounded align="middle"
                        :label="customers.paginatorInfo.total"></q-badge>
                </h4>
                <div :key="pcu" v-for="(customer, pcu) in customers.data" class="-item"
                    :class="{'-is-last-child' : pcu==customers.data.length-1}">
                    <div class="-name">
                        <span>
                            {{ customer.name}}
                            <q-icon class="q-mr-xs cursor-pointer" name="find_replace"
                                title="Rechercher la phrase exacte" size="16px"
                                @click.stop="sentenceMatch=true; searchText=customer.name;" />
                        </span>
                        <UserProfileInfo :userProfile="customer" class="q-mr-xs" :size="'16px'" />
                    </div>
                    <div class="-description">
                        <span class="q-mr-sm text-no-wrap" v-if="customer.email && customer.email.trim()!=''">
                            {{ customer.email }}
                            <q-icon class="q-mr-xs cursor-pointer" name="find_replace"
                                title="Rechercher la phrase exacte" size="16px"
                                @click.stop="sentenceMatch=true; searchText=customer.email;" />
                        </span>

                        <span v-if="customer.relevance!=null" class="q-mr-sm text-no-wrap -faded"
                            title="Pertinence de recherche">
                            <q-icon class="-icon q-mr-xs" name="trending_up" />
                            {{ customer.relevance.toFixed(3) }}
                        </span>

                    </div>
                </div>
                <div v-if="customers.paginatorInfo.hasMorePages" class="-load-more">
                    <span class="cursor-pointer" v-if="!$apollo.loading"
                        @click.stop="loadMoreResults(customers.paginatorInfo.currentPage+1, 'customers')">
                        Charger plus de résultats ({{customers.paginatorInfo.total-customers.data.length}})
                    </span>
                    <span v-else class="is-disabled">
                        Charger plus de résultats ({{customers.paginatorInfo.total-customers.data.length}})
                    </span>
                </div>
            </div>



            <div class="-result-group no-wrap" :class="{ 'has-results': contacts.data.length>0 }">
                <h4 class="" onclick="this.closest('.-result-group').classList.toggle('is-collapsed');">
                    <q-icon name="expand_more" class="-button-expand" />
                    Contacts
                    <q-badge class="-badge float-right q-mr-xs" size="sm" rounded align="middle"
                        :label="contacts.paginatorInfo.total"></q-badge>
                </h4>
                <div :key="pc" v-for="(contact, pc) in contacts.data" class="-item"
                    :class="{'-is-last-child' : pc==contacts.data.length-1}">
                    <div class="-name">
                        <span>
                            {{ contact.name}}
                            <q-icon class="q-mr-xs cursor-pointer" name="find_replace"
                                title="Rechercher la phrase exacte" size="16px"
                                @click.stop="sentenceMatch=true; searchText=contact.name;" />
                        </span>
                        <UserProfileInfo :userProfile="contact" class="q-mr-xs" :size="'16px'" />
                    </div>
                    <div class="-description" v-if="contact.email && contact.email.trim()!=''">
                        <span class="q-mr-sm text-no-wrap" v-if="contact.email && contact.email.trim()!=''">
                            {{ contact.email }}
                            <q-icon class="q-mr-xs cursor-pointer" name="find_replace"
                                title="Rechercher la phrase exacte" size="16px"
                                @click.stop="sentenceMatch=true; searchText=contact.email;" />
                        </span>

                        <span v-if="contact.relevance!=null" class="q-mr-sm text-no-wrap -faded"
                            title="Pertinence de recherche">
                            <q-icon class="-icon q-mr-xs" name="trending_up" />
                            {{ contact.relevance.toFixed(3) }}
                        </span>
                    </div>
                </div>
                <div v-if="contacts.paginatorInfo.hasMorePages" class="-load-more">
                    <span class="cursor-pointer" v-if="!$apollo.loading"
                        @click.stop="loadMoreResults(contacts.paginatorInfo.currentPage+1, 'contacts')">
                        Charger plus de résultats ({{contacts.paginatorInfo.total-contacts.data.length}})
                    </span>
                    <span v-else class="is-disabled">
                        Charger plus de résultats ({{contacts.paginatorInfo.total-contacts.data.length}})
                    </span>
                </div>
            </div>



            <div class="-result-group no-wrap" :class="{ 'has-results': totalCount==0 && !$apollo.loading }">
                <div class="-item -no-result">
                    <q-icon name="warning" class="q-mr-xs"></q-icon>
                    La recherche ne retourne aucun résultat
                </div>
            </div>



            <!-- </div> -->
        </q-menu>
    </div>
</template>

<script>
    import { GLOBALSEARCH } from "@/graphql/search/queries"

    export default {
        name: 'GlobalSearch',
        //components: { Component1, Component2 },
        props: {
            currentDate: String,
        },
        data(){
        	return {
                searchTo: null,
                searchText: null,
                searchSkipped: true,
                searching: true,
                sentenceMatch: false,
                searchFilters: [],
                statusFilter: null,
                // wantSentenceMatch: false,
                perPage: 5,
                projects: {
                    data: [],
                    paginatorInfo: {}
                },
                userProfiles: {
                    data: [],
                    paginatorInfo: {}
                },
                customers: {
                    data: [],
                    paginatorInfo: {}
                },
                contacts: {
                    data: [],
                    paginatorInfo: {}
                },
                totalCount: 0,
                loading: false,
                previousSearch: "",
                selectedItem: -1,
                $document: null
                // selectedItem: 0
        	}
        },
        mounted(){
            let searchFilters = this.$q.localStorage.getItem('searchFilters');
            if(searchFilters) this.searchFilters=searchFilters;
            document.addEventListener('keydown', this.initSearch);
            // document.addEventListener('keypress', this.initSearch);
            this.$document = document;
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.initSearch);
            clearTimeout(this.searchTo)
        },
        //computed: {},
        watch: {
            loading: function(){
                if(!this.loading){
                    let totalCount=0;
                    totalCount=this.projects.data.length+this.userProfiles.data.length+this.customers.data.length+this.contacts.data.length;
                    this.totalCount=totalCount;
                    // this.sentenceMatch=false;
                }
            },
            searchText: function(){
                clearTimeout(this.searchTo)
                // if(this.searchText && this.searchText.length>1){
                // if(this.searchText){
                    this.searching=true;
                    this.searchSkipped=false;
                    this.searchTo = setTimeout(function(){
                        this.$refs['js-search-result'].show();
                    }.bind(this), 500);
                // }else{
                //     this.searchSkipped=true;
                //     this.searchTo = setTimeout(function(){
                //         this.$refs['js-search-result'].hide();
                //     }.bind(this), 500);
                // }
            }
        },
        methods: {

            initSearch(event){

                if(event.key=="k" && (event.ctrlKey || event.metaKey)) {
                    event.stopPropagation();
                    document.querySelector('.c-header').classList.add('is-search-active');
                    document.querySelector('.js-search_input').select();
                    document.querySelector('.js-search_input').focus();
                    this.selectedItem=-1
                    this.$scrollTo('#containerTop', 50, {offset: 0, container: '#js-search-result'}) //fix timing bad offset
                    this.showResults()
                }

                if(event.key=="ArrowDown"){
                    if(!this.selectedItemObj) this.selectedItemObj="projects"
                    if(this.selectedItem !==null && !this.loading && (this.selectedItem<this.projects.data.length-1 || this.$refs.loadMoreProjects)){
                        this.selectedItem=this.selectedItem+1;
                        if(this.$refs.loadMoreProjects && this.selectedItem>=this.projects.data.length){
                            this.$refs.loadMoreProjects.click()
                        }
                    }
                }
                if(event.key=="ArrowUp"){
                    if(this.selectedItem) this.selectedItem = this.selectedItem-1;
                }

                if(event.key=="ArrowDown" || event.key=="ArrowUp"){
                    if(this.$refs['projectGS-'+this.selectedItem]){
                        this.$scrollTo("#projectGS-"+this.selectedItem, 50, {offset: -100, container: '#js-search-result'}) //fix timing bad offset
                    }
                }

                if(event.key=="Enter" && this.selectedItem>-1){
                    if(this.$refs['projectGS-'+this.selectedItem]){
                        this.$refs['projectGS-'+this.selectedItem][0].click()
                    }
                }
            },

            setStatusFilter(status){
                if(this.statusFilter==status){
                    this.statusFilter=null
                }else{
                    this.statusFilter=status
                }
            },

            setSearchFilters(filter, toggle=null){
                if(this.searchFilters.includes(filter)){
                    this.searchFilters=this.searchFilters.filter(obj => obj!=filter)
                }else{
                    this.searchFilters.push(filter);
                    if(toggle){
                        toggle.forEach(function(item){
                            this.searchFilters=this.searchFilters.filter(obj => obj!=item)
                        }.bind(this))
                    }
                }
                this.$q.localStorage.set('searchFilters', this.searchFilters)
            },
            jumpToProject(project){
                let date=project.start_date
                if(this.currentDate>=project.start_date && this.currentDate<=project.end_date){
                    date=this.currentDate;
                }
                this.$eventBus.$emit('jump-to-project', {projectID: project.id, currentDate: date})
                document.querySelector('.c-header').classList.remove('is-search-active');
                document.querySelector('.js-search_input').blur();
                this.$refs['js-search-result'].hide();
            },
            showResults(){
                // if(this.searchText && this.searchText.length>1){
                // if(this.searchText){
                clearTimeout(this.searchTo)
                this.searching=true;
                this.searchSkipped=false;
                this.searchTo = setTimeout(function(){
                    if(!this.loading) this.$refs['js-search-result'].show();
                    if(this.$apollo.queries.globalSearch) this.$apollo.queries.globalSearch.refresh();
                }.bind(this), 500);
                                    // }
            },
            loadMoreResults(page, type){
                // this.searchSkipped=false;
                this.$apollo.queries.globalSearch.fetchMore({
                    variables: {
                        page: page,
                        loadMore: type
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        let newData=JSON.parse(JSON.stringify(previousResult));

                        if(newData.globalSearch[type] && fetchMoreResult.globalSearch[type]) {
                            newData.globalSearch[type].paginatorInfo = fetchMoreResult.globalSearch[type].paginatorInfo
                            newData.globalSearch[type].data=[
                                ...newData.globalSearch[type].data,
                                ...fetchMoreResult.globalSearch[type].data
                            ]
                        }
                        
                        this.$refs['js-search-result'].show();

                        return newData;
                    },
                })
            }
        },
        apollo: {
            globalSearch: {
                query: GLOBALSEARCH,
                fetchPolicy: 'cache-and-network',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
                debounce: 500,
                skip() {
                    return this.searchSkipped
                },
                watchLoading(isLoading){
                    this.loading=isLoading;
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                variables() {
                    return {
                        search: this.searchText,
                        searchFilters: this.searchFilters,
                        sentenceMatch: this.sentenceMatch,
                        status: this.statusFilter,
                        // currentDate: this.currentDate,
                        first: this.perPage
                    }
                },
                update(data) {
                    if(data.globalSearch){
                        this.projects=data.globalSearch.projects
                        this.userProfiles=data.globalSearch.userProfiles
                        this.customers=data.globalSearch.customers
                        this.contacts=data.globalSearch.contacts
                    }
                    if(this.searching) this.$refs['js-search-result'].show();
                    this.searching=false;
                    // this.searchSkipped=true;
                    return data
                },
            }
        }
    }
</script>

<style lang="scss">
    
    @import "@/scss/components/nav/GlobalSearch.scss";
    /*
    html body .q-menu {
        // max-height: calc(100vh - 60px);

        &--square {
            box-shadow: none;
            border-top: 1px solid $color-1;
        }
    }*/
</style>